export enum MedicinePresentationTypeEnum {
    Frasco = 2,
    Aplicador = 3,
    Comprimido = 4,
    Gota = 5,
    Capsula = 6,
    Outro = 7,
}